import '../App.css';
import Equal from '../assets/equal.svg';
import { useState } from 'react';
import Close from '../assets/close.svg';
import Confirmation from './Confirmation';

import { PaymentElement, useStripe, useElements, AddressElement } from '@stripe/react-stripe-js';

import c from '../assets/config';

function Checkout({setPayment, currentCart, cartSize, resetOrder}) {
    const elements = useElements()
    const stripe = useStripe()
    const [errorMessage, setErrorMessage] = useState(null)
    const [payAttempt, setAttempt] = useState(false)

    //const dotcolors = ['darkblue','gray', 'darkred', 'orange', 'rgb(180,155,47)', 'yellow', 'green', 'lightblue']

    //set confirmation
    const [confWindow, setConf] = useState(false)
    const [message, setMessage] = useState(null)
    const [receipt, setReceipt] = useState(false)

    async function submitPayment(event){
        event.preventDefault()
        setAttempt(true)

        if(!stripe || !elements) {
            return
        }

        const {error} = await stripe.confirmPayment({
            elements,
            redirect:'if_required',
            confirmParams: {
                return_url: c.baseurl
            }
        })
        if(error) {
            setErrorMessage(error.message)
            setAttempt(false)
            console.log(error)
            console.log(errorMessage)
        }
        setConf(true)
    }

    function reset() {
        setConf(false)
        setMessage(null)
        setReceipt(false)
        resetOrder()
        setAttempt(false)
    }

  return (
        <div className='page' style={{background:'white'}}>
            <div className='checkoutList'>
                {confWindow == true ?
                    receipt == true ?
                    <>
                        <div className='text'>
                            Purchase complete
                        </div>
                        <div className='text'>
                            Your order will ship tomorrow
                        </div>
                        <div className='text'>
                            Total Paid: ${cartSize*c.products[0].price}
                        </div>
                        <div className='text'>
                            Items: {cartSize}
                        </div>
                        <div style={{height:'1px', border:'1px solid black', width:'300px'}} />
                        {
                            currentCart.map((item, index) => {
                                return (
                                    item > 0 ?
                                    <div className='checkoutItem' key={index}>
                                        <div className='colorcircle' style={{backgroundColor:c.products[0].dotcolors[index]}}/>
                                        <img style={{padding:'3px', margin:'10px'}} src={Close} />
                                        <div className='text'>
                                            {item}
                                        </div>
                                        <img style={{padding:'3px', margin:'10px', height:'30px'}} src={Equal} />
                                        <div className='text'>
                                            ${(item*c.products[0].price)}
                                        </div>
                                    </div>
                                    :""
                                )
                            })
                        }
                        <div onClick={()=>reset()} className='text normalbutton'>
                            Continue
                        </div>
                    </>
                    :
                    <>
                        <div className='text'>Waiting for payment to complete</div>
                        <div className='text'>
                            {message}
                        </div>
                    </>
                :
                    <>
                    {
                        currentCart.map((item, index) => {
                            return (
                                item > 0 ?
                                <div className='checkoutItem' key={index}>
                                    <div className='colorcircle' style={{backgroundColor:c.products[0].dotcolors[index]}}/>
                                    <img style={{padding:'3px', margin:'10px'}} src={Close} />
                                    <div className='text'>
                                        {item}
                                    </div>
                                    <img style={{padding:'3px', margin:'10px', height:'30px'}} src={Equal} />
                                    <div className='text'>
                                        ${(item*c.products[0].price)}
                                    </div>
                                </div>
                                :''
                            )
                        })
                    }
                    <div style={{height:'1px', border:'1px solid black', width:'300px'}} />
                    <div className='text'>
                        Shipping: {c.shipping == 0?"Free":c.shipping}
                    </div>
                    <div className='text'>
                        Total: ${cartSize*c.products[0].price}
                    </div>
                    <AddressElement options={{
                        mode: 'shipping',
                        allowedCountries: ['US'],
                        blockPoBox: false,
                    }}/>
                    <PaymentElement />
                    </>
                }
                <div className='box stack'>
                    {confWindow == true ?
                        receipt == true ?
                            <></>
                        :
                        <>
                            <div className='text normalbutton' style={{marginRight:'20px', color:'gray'}}>
                                Cancel
                            </div>
                            <div className='text normalbutton box'>
                                <Confirmation currentCart={currentCart} setConf={setConf} message={message} setMessage={setMessage} setReceipt={setReceipt} />
                            </div>
                        </>
                    :
                        <>
                            <div onClick={()=>setPayment(false)} className='text normalbutton' style={{marginRight:'20px'}}>
                                Cancel
                            </div>
                            <div onClick={(event)=>submitPayment(event)} className='text normalbutton box'>
                                {payAttempt == true ?
                                    <div className='spinner' />
                                    :
                                    'Pay'
                                }
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
  );
}

export default Checkout;